import styled from 'styled-components'
import { minHeight, MinHeightProps, padding, PaddingProps } from 'styled-system'
import { themeGet } from '@styled-system/theme-get'

import { DIV_SHOULD_FORWARD_PROP } from 'Config/shouldForwardProp'
import { motion } from 'framer-motion'

import { LANDING_MAX_CONTENT_WIDTH_PX } from 'Constants/Landing'

export const Container = styled.header<PaddingProps>`
  position: fixed;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  z-index: ${themeGet('zIndices.header')};

  ${padding}
`

export const Background = styled(motion.div)`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
  background-color: ${themeGet('colors.surface.block')};
`

const shouldForwardProp = (prop: string | number) => {
  return !DIV_SHOULD_FORWARD_PROP.includes(String(prop))
}

export const Content = styled.div.withConfig({
  shouldForwardProp,
})<MinHeightProps & PaddingProps>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  max-width: ${LANDING_MAX_CONTENT_WIDTH_PX}px;
  z-index: 2;
  gap: ${themeGet('space.5')}px;

  ${minHeight}
  ${padding}
`

export const MobileMenuHolder = styled(motion.div)<PaddingProps>`
  position: fixed;
  display: flex;
  justify-content: flex-end;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 0;
  background-color: ${themeGet('colors.surface.block')};
  overflow: hidden;
  opacity: 1;

  ${padding}
`
